// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"283":"a8f51d20","719":"951ecfb8","762":"b6b3350b"}[chunkId] + ".js";
};